import { render, staticRenderFns } from "./FeatureMessage.vue?vue&type=template&id=f27c5ad0"
import script from "./FeatureMessage.vue?vue&type=script&lang=js"
export * from "./FeatureMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports